(ns frontend.view.settings2.export-data.events
  (:require
   [clojure.string :as string]
   [potpuri.core :as potpuri]
   [reagent.core :as r]
   [frontend.conn :as conn]
   [promesa.core :as p]
   [common.localization :as loc]
   [frontend.view.settings2.export-data.db :as db]
   [frontend.analytics :as analytics]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.entity.view :as entity-modal]
   [frontend.view.modals.notification.view :as notification-modal]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.actions.excel-export :as excel-export-actions]
   [frontend.actions.tenant :as tenant-actions]))

(defn set-alert!
  [kw text]
  (swap! db/state update-in [:alerts] assoc kw text))

(defn hide-alert!
  [kw]
  (swap! db/state update-in [:alerts] dissoc kw))

(defn start-export!
  []
  (swap! db/state assoc :exporting? true))

(defn end-export!
  [job-id]
  (let [job (get @session/entities job-id)]
    (swap! db/state dissoc :exporting?)
    (let [url (:job/result job)]
      (when url
        (.open js/window url "_download")))))

(defn export-data!
  []
  (let [exporting? (:exporting? @db/state)]
    (when-not exporting?
      (start-export!)
      (-> (conn/sendp! :export/all-data {} 60000)
          (p/then (fn [resp]
                    (let [job (:body resp)
                          job-id (:db/id job)]
                      (session/wait-for-entity-attribute-value! job-id
                                                                :job/status
                                                                [:job.status/finished :job.status/error]
                                                                (partial end-export! job-id)))))
          (p/catch (fn [e]
                     (end-export! nil)
                     (some->> e
                              :message
                              (set-alert! :export))
                     (logging/error "Unable to export company data" e))))
      (analytics/event "Data-exported"))))
